import React from "react"
import classNames from "classnames"

import { useTranslation } from "@/locales"
import { SFX } from "@/topic/rogue_5/utils/sfx"
import { needFixWritingMode } from "@/utils/misc"

import styles from "./index.module.less"

const getCountDown = () => {
    const now = new Date()
    const target = new Date("2025-12-18 15:00:00")
    const diff = target.getTime() - now.getTime()
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24))

    return days.toFixed(0).padStart(2, "0")
}

const LobbyButton: React.FC<{
    type: "pink" | "blue"
    text: string
    textEn: string
    className?: string
    style?: React.CSSProperties
    lock?: boolean
    onClick?: () => void
}> = ({ className, style, type, text, textEn, onClick, lock }) => {
    const { t } = useTranslation()
    return (
        <div
            className={classNames(
                styles.LobbyButton,
                styles[type],
                needFixWritingMode() && styles.safari,
                className
            )}
            style={style}
            onClick={() => {
                onClick?.()
                SFX.play("click")
            }}
            onMouseEnter={() => {
                SFX.play("lobbyButtonHover")
            }}
        >
            <div className={classNames(styles.container, lock && styles.lock)}>
                <div className={styles.shadow}></div>
                <div className={styles.flag}></div>
                <div className={styles.textCn}>
                    <div className={styles.mark}></div>
                    <div className={styles.textLine}>{text}</div>
                </div>
                <div className={styles.textEn}>
                    {textEn.split("/n").map((line, index) => (
                        <div className={styles.textLine} key={index}>
                            {line}
                        </div>
                    ))}
                    <div className={styles.decoLine}></div>
                </div>
            </div>

            {lock && (
                <div className={styles.countDown}>
                    <div className={styles.text}>
                        <div className={styles.label}>
                            {t("game.lobby.button.countdown")}
                        </div>
                        <div className={styles.value}>
                            {t("game.lobby.button.countdown.value").replace(
                                "$0",
                                getCountDown()
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default LobbyButton
